import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
type CountdownProps = {
  startSeconds?: number;
  className?: string;
};
function format(total: number): string {
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
export function Countdown({
  startSeconds = 622,
  className = ''
}: CountdownProps) {
  const [remaining, setRemaining] = useState(startSeconds);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  return <p className={`flex items-center gap-2 text-sm font-semibold text-clay-600 ${className}`} data-id="element-42" data-mp="372t6uvw2f50n">
      <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-43" data-mp="10cbubkmtn7gd" />
      <span data-id="element-44" data-mp="10cv42e2bipjb">
        Oferta termina en{' '}
        <span className="font-display tabular-nums" aria-live="off" data-id="element-45" data-mp="15b698bho4bv7">
          {format(remaining)}
        </span>
      </span>
    </p>;
}